import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../_services/login.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    isLoginTab = true
    loginForm: FormGroup;
    submitted = false;
    constructor(
        private formBuilder: FormBuilder,
        private loginService: LoginService,
        private router: Router,
        private toastr: ToastrService
      ) { }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            emailAddress: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });

    }

    // convenience getter for easy access to form fields
    get formFields() { return this.loginForm.controls; }

    login() {
        this.submitted = true;
        if (this.loginForm.invalid) {
            return;
        }
        const obj = this.loginForm.value;
        this.loginService.login(obj)
        .pipe(first())
        .subscribe(result => {
          console.log('result >>', result)
          if(result.data){
              this.toastr.success('Successfully logged in!', 'Success');
             this.router.navigate(['/dashboard']);
           }else {
             console.log('result.message >>', result.message)
             this.toastr.error(result.message, 'Error');
           }
        });

    }

}
